import request from "../utils/request";

export const YOUTUBE_API = {
    listVideos: (channelId, page = 1, limit = 25) => {
        return request.get(`/youtube/channels/${channelId}/videos`, { params: { page, limit } });
    },

    syncVideos: (channelId) => {
        return request.post(`/youtube/channels/${channelId}/videos/sync`);
    },

    getVideo: (videoId) => {
        return request.get(`/youtube/videos/${videoId}`);
    },

    listComments: (data) => {
        return request.post(`/youtube/comments`, data);
    },

    fetchComments: (channelId, videoId, pageToken) => {
        const params = pageToken ? { pageToken } : {};
        return request.get(`/youtube/channels/${channelId}/videos/${videoId}/fetch-comments`, { params });
    },

    replyComment: (commentId, data) => {
        return request.post(`/youtube/comments/${commentId}/reply`, data);
    },

    updateStatus: (commentId, status, assigneeId) => {
        return request.put(`/youtube/comments/${commentId}/status`, { status, assigneeId });
    },

    likeComment: (commentId, channelId) => {
        return request.post(`/youtube/comments/${commentId}/like`, { channelId, rating: "like" });
    },

    setModerationStatus: (commentId, channelId, moderationStatus, banAuthor = false) => {
        return request.post(`/youtube/comments/${commentId}/moderation`, { channelId, moderationStatus, banAuthor });
    },
};
